import React from 'react';
import { motion } from 'framer-motion';
import { projects } from '../../data/projects';
import type { ProjectLayout } from '../../types/content';
import { LinkButton } from '../LinkButton';
import { ProjectCard } from './ProjectCard';

// Recreates the offset, editorial grid from the original layout.
const layoutClass: Record<ProjectLayout, string> = {
  // Feature rows span both columns: LUKSO is centred, the other feature rows are nudged in from the left.
  'nudge-flush': 'w-full sm:col-span-2 sm:max-w-[52.19em] sm:justify-self-center',
  nudge: 'w-full sm:col-span-2 sm:max-w-[52.19em] lg:ml-[5%]',
  full: 'w-full',
  medium: 'w-full lg:mx-auto lg:max-w-[27rem]',
  small: 'w-full lg:mr-auto lg:max-w-[22rem]'
};
export function Projects() {
  return <section id="work" aria-label="Selected work" className="pb-0 sm:pb-[9.625rem]" data-id="element-143" data-mp="g1fmek74h444">
      <div className="sm:px-5 md:px-10" data-id="element-144" data-mp="13rtf8cxj76zr">
        <div className="mx-auto max-w-[71.875rem]" data-id="element-145" data-mp="18jkye2ecyafv">
          <div className="grid grid-cols-1 gap-y-[7rem] sm:grid-cols-2 sm:gap-12 md:gap-x-20 md:gap-y-[7rem] lg:items-center lg:justify-items-start lg:gap-x-[10.875rem] lg:gap-y-[9.375rem]" data-id="element-146" data-mp="18l4bjk4pw5df">
            {projects.map((project, i) => <motion.div key={`${project.title}-${i}`} initial={{
            opacity: 0,
            y: 60,
            scale: 0.92
          }} whileInView={{
            opacity: 1,
            y: 0,
            scale: 1
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.8,
            delay: i % 2 * 0.15,
            ease: [0.25, 0.46, 0.45, 0.94]
          }} className={layoutClass[project.layout]} data-id="element-147" data-mp="25uh3x9szcehi" data-mpi={i}>
                <ProjectCard project={project} data-id="element-148" data-mp="2otuyntyj9t92" />
              </motion.div>)}
          </div>
          <div className="mt-[6.25rem] flex justify-center sm:mt-[7.5rem]" data-id="element-149" data-mp="2jvjrjqzmhwuj">
            <LinkButton label="View more" href="#work" variant="muted" data-id="element-150" data-mp="uf26y60rtmme" />
          </div>
        </div>
      </div>
    </section>;
}